import fetchConsolidated from './fetchConsolidatedQuotation'
import sendConsolidated from './sendConsolidated'
import sendRejectedQuotations from './sendRejectedQuotations'
import uploadFileQuotation from './uploadFileQuotation'
import updateSuppliesQuotation from './updateSuppliesQuotation'
import quotationApprove from './quotationApprove'
import toPurchaseOrden from './toPurchaseOrden'
import quotationReject from './quotationReject'
import sendEmailProvider from './sendEmailProvider'
import searchQuotation from './searchQuotation'
import fetchStatus from './fetchStatus'

export default {
  fetchConsolidated,
  sendConsolidated,
  sendRejectedQuotations,
  uploadFileQuotation,
  updateSuppliesQuotation,
  quotationApprove,
  toPurchaseOrden,
  quotationReject,
  sendEmailProvider,
  searchQuotation,
  fetchStatus
}


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/index.js